import { Injectable, Signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ASSIGNMENT_ACTIONS } from '@data-access/assignment/actions';
import {
  getCurrentAssignmentForm,
  getSearchResults,
  getSearchResultsError,
} from '@data-access/assignment/selectors';
import {
  Assignment,
  AssignmentReqBody,
  FormConfig,
  KnownEntities,
} from '@data-access/assignment/types';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class AssignFacadeService {
  private readonly _store = inject(Store);
  currentAssignmentView = toSignal(
    this._store.select(getCurrentAssignmentForm),
  ) as Signal<FormConfig>;
  errorSearchResult = toSignal(
    this._store.select(getSearchResultsError),
  ) as Signal<boolean>;
  getResults = toSignal(this._store.select(getSearchResults));

  lookupEntity(entity: string, searchVal: string): void {
    this._store.dispatch(
      ASSIGNMENT_ACTIONS.searchEntity({
        entity: entity,
        query: searchVal,
      }),
    );
  }

  assignEntitySave(
    entity: KnownEntities,
    targetType: string,
    targetId: string,
    studyId: string,
    body: AssignmentReqBody,
  ) {
    this._store.dispatch(
      ASSIGNMENT_ACTIONS.submitAssignment({
        props: {
          body,
          entity,
          targetId,
          targetType,
          studyId
        },
      }),
    );
  }

  switchFormConfig(res: FormConfig) {
    this._store.dispatch(
      ASSIGNMENT_ACTIONS.switchForm({
        ...res,
      }),
    );
  }

  startAssignment(targetId: string, assignmet: Assignment) {
    this._store.dispatch(
      ASSIGNMENT_ACTIONS.startNewAssignment({
        ...assignmet,
        currentForm: null,
        targetId: targetId,
      }),
    );
  }
}
